/**
 * `/plans/buddy`: the conversation's address in wave 1 (30 September to 2 October 2026), before AI
 * Buddy became a module at `/buddy`. Kept as a redirect so a bookmark or an old link still lands,
 * carrying the client it named.
 *
 * A STATIC segment beside `/plans/nowy`, so TanStack Router ranks it above `/plans/$planId`.
 * `replace: true`, so the old address leaves no history entry to bounce Back off.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { validateAiPlanBuilderSearch } from '~/pages/ai-plan-builder';

export const Route = createFileRoute('/_shell/plans/buddy')({
  validateSearch: validateAiPlanBuilderSearch,
  beforeLoad: ({ search }) => {
    // `throw: true` makes `redirect` raise the router's own Response itself; see `_shell.tsx`.
    redirect({ to: '/buddy', search: search.klient === undefined ? {} : { klient: search.klient }, replace: true, throw: true });
  },
});
